var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBellFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_38638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50443 13.5952H4.50454C4.23484 13.5952 4.0375 13.8625 4.12335 14.1219C4.38713 14.9191 5.12959 15.4935 6.00449 15.4935C6.87939 15.4935 7.62184 14.9191 7.88562 14.1219C7.9714 13.8626 7.77406 13.5952 7.50443 13.5952Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9924 2.4051H4.93719C4.75245 2.4051 4.61726 2.1378 4.676 1.87845C4.85675 1.08119 5.36542 0.506836 5.96483 0.506836C6.56425 0.506836 7.07285 1.08119 7.25359 1.87845C7.31233 2.13772 7.17722 2.4051 6.9924 2.4051Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.101074 12.2577V12.2573C0.100926 12.0176 0.198927 11.789 0.371078 11.6335C0.816787 11.231 1.64954 10.0744 1.57183 7.08364C1.50902 4.66383 2.32177 3.24526 3.29637 2.41351C4.84765 1.0896 7.13531 1.08862 8.68867 2.41118C9.66446 3.24203 10.4795 4.65993 10.4203 7.07974C10.3471 10.0711 11.182 11.2269 11.6282 11.6288C11.8005 11.784 11.8988 12.0123 11.8989 12.2519C11.8993 12.7057 11.5522 13.0739 11.1238 13.0741L0.876862 13.0785C0.448708 13.0788 0.101445 12.7113 0.101074 12.2577Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_38638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.7979,
    height: 14.9865,
    fill: "white",
    transform: "translate(0.101074 0.506836)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellFill);
export default __webpack_public_path__ + "static/media/icon-bell-fill.d466e9beb5f43c02caf62228a9a4cf74.svg";
export { ForwardRef as ReactComponent };